webpackJsonp([327],{

/***/ 1028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.2.1Rc.1 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1843:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1028),
  /* template */
  __webpack_require__(2225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.2.1-rc.1-219.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.2.1-rc.1-219.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4d227973", Component.options)
  } else {
    hotAPI.reload("data-v-4d227973", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2225:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.2.1Rc.1 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/cell-box.html"
    }
  }, [_vm._v("CellBox")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 prop:border-intent, 用以不显示边框与左边间隙")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/cell-form-preview.html"
    }
  }, [_vm._v("CellFormPreview")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 prop:border-intent, 用以不显示边框与左边间隙")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 prop:border-intent, 用以不显示边框与左边间隙")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持 prop:arrow-direction, 用以在折叠场景下动态更改方向")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/checklist.html"
    }
  }, [_vm._v("Checklist")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 prop:check-disabled")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup-picker.html"
    }
  }, [_vm._v("PopupPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复错误的弹窗关闭类型 #1209")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d227973", module.exports)
  }
}

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1843);

/***/ })

});


// WEBPACK FOOTER //
// 327.a6828f58.js